var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"story-shell"},[_c('iframe',{staticClass:"story-frame",attrs:{"src":_vm.storySource,"title":"라피아 공주 이야기","allow":"fullscreen"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }